import { APPOINTMENT_STATUS } from "@elixir/types";

export const paymentStatusMap: Record<string, string> = {
  created: "pending",
  payment_initiated: "pending",
  cancelled: "pending",

  payment_success: "paid",
  payment_processing: "paid",
  success: "paid",
  settled: "paid",

  unbilled: "unbilled",

  receipt_generated: "paid",

  refunded: "refunded",
  refund_processed: "refunded",
  to_refund: "refunded",

  payment_failed: "failed",
  failed: "failed",
};

export const GENDER_TO_INITIAL_MAP = {
  Male: "M",
  Female: "F",
  Others: "O",
};

export const appointmentStatusForActiveAppointments = [
  APPOINTMENT_STATUS.ONGOING,
  APPOINTMENT_STATUS.COMPLETED_NO_PRESCRIPTION,
  APPOINTMENT_STATUS.NO_SHOW,
  APPOINTMENT_STATUS.NO_SHOW_DOCTOR,
  APPOINTMENT_STATUS.NO_SHOW_STAFF,
  APPOINTMENT_STATUS.ABORTED,
  APPOINTMENT_STATUS.COMPLETED,
  APPOINTMENT_STATUS.BOOKED,
  APPOINTMENT_STATUS.PARKED,
  APPOINTMENT_STATUS.CHECKED_IN,
];
